import React from 'react';
import { PageSection } from '../PageSection';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { PRODUCT_NAME } from '../../data/salesContent';
export function OfferSection() {
  return <PageSection id="oferta" labelledBy="offer-title" data-id="element-126" data-mp="aithzttqw3a3">
      <div className="rounded-2xl border-2 border-accent-500 bg-carbon-900 p-6 text-center md:p-10" data-id="element-127" data-mp="ai9zaaw9tav0">
        <p className="font-display text-base font-extrabold uppercase tracking-[0.3em] text-accent-400" data-id="element-128" data-mp="6irdlcwmkvr4">Oferta especial</p>
        <h2 id="offer-title" className="mt-3 text-3xl font-extrabold uppercase leading-[1.05] text-white md:text-[2.5rem]" data-id="element-129" data-mp="1oex9bqg40jl">
          {PRODUCT_NAME}
        </h2>
        <p className="mx-auto mt-3 max-w-md text-base font-semibold uppercase leading-snug text-carbon-300" data-id="element-130" data-mp="3nz0wsyzvlabz">
          El sistema completo para enseñar el proceso constructivo de principio a fin
        </p>
        <ProductImage className="mx-auto mt-6 w-full max-w-lg" data-id="element-131" data-mp="3exjklrpl9ssk" />
        <div className="mt-6 font-display text-2xl font-extrabold uppercase leading-snug tracking-wide md:text-3xl" data-id="element-132" data-mp="1arih0eg6fqeu">
          <p className="text-white" data-id="element-133" data-mp="1fjsdyefplqqm">10 volúmenes completos</p>
          <p className="text-accent-400" data-id="element-134" data-mp="10tuj5fn9y2sg">+ 5 bonos prácticos</p>
        </div>
        <div className="mx-auto my-8 h-px max-w-md bg-carbon-700" aria-hidden="true" data-id="element-135" data-mp="10rrogib6flhe" />
        <PriceBlock lead="Hoy por" notes={['Pago único', 'Acceso digital inmediato']} data-id="element-136" data-mp="15t76e1i25bvk" />
        <div className="mt-7" data-id="element-137" data-mp="1tj1ksni0z8hx">
          <CtaButton data-id="element-138" data-mp="1tgp6qlfe1ia5">Quiero mi Mega Pack Técnico en Construcciones 360</CtaButton>
        </div>
      </div>
    </PageSection>;
}